import { DateTime, Interval } from 'luxon';
import { Instance, flow, types } from 'mobx-state-tree';

import AuthModel from '@common/models/Auth';
import Chat from '@common/models/Chat';
import Notifications from '@common/models/Notifications/Notifications';
import ServiceTemplates from '@common/models/ServiceTemplates/ServiceTemplates';
import Services from '@common/models/Services/Services';

const StoreInterface = types
	.model('Store', {
		auth: types.optional(AuthModel, {}),
		services: types.optional(Services, {}),
		serviceTemplates: types.optional(ServiceTemplates, {}),
		chat: types.optional(Chat, {}),
		notifications: types.optional(Notifications, {}),
		modalNotifications: types.optional(Notifications, {}),
	})
	.volatile(() => ({
		loading: true,
		streamApiKey: undefined as string | undefined,
		appEnvironment: undefined as string | undefined,
	}))
	.views(() => ({
		get week() {
			return Interval.fromDateTimes(
				DateTime.now().startOf('week'),
				DateTime.now().endOf('week'),
			).splitBy({ days: 1 });
		},
	}))
	.actions((self) => ({
		_fetch: flow(function* () {
			try {
				yield self.services.fetch();
				yield self.serviceTemplates.fetch();
			} catch (e) {
				// @TODO: Process store fetch error
				console.error('store interface fetch', e);
				throw e;
			}
		}),
		addStreamKey(key?: string) {
			if (key) {
				self.streamApiKey = key;
			}
		},
		addAppEnvironment(environment?: string) {
			if (environment) {
				self.appEnvironment = environment;
			}
		},
	}));

export default StoreInterface;

export interface IStoreInterfaceModel extends Instance<typeof StoreInterface> {}
